// Prüfungen vor dem Senden (aus ReplyBox ausgelagert, damit sie testbar sind).
import type { Draft, Mailbox } from '@mail/shared';
import type { AddressInput } from './addresses.ts';
import { splitZitat } from './zitat.ts';

// Nur der eigene Text zählt – nicht der zitierte Verlauf und nicht der Weiterleitungskopf (splitZitat
// kennt den mm-quote-Rahmen und alte Entwürfe, bei denen nur Kopfzeile + blockquote übrig sind).
export function eigenerText(html: string): string {
  return splitZitat(html)
    .eigen.replace(/<blockquote[\s\S]*?<\/blockquote>/g, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ');
}

// Prüfungen vor dem Senden. Liefert kurze deutsche Hinweise; leer = nichts auffällig.
export function sendeWarnungen(a: {
  html: string;
  mailboxId: number;
  draft: Draft;
  mailboxes: Mailbox[];
  to: AddressInput[];
}): string[] {
  const out: string[] = [];
  const text = eigenerText(a.html);
  if (
    /\b(anbei|im anhang|angehängt|beigefügt|attached)\b/i.test(text) &&
    !a.draft.attachmentRefs.length
  )
    out.push('Im Text steht „anbei/im Anhang“, aber es hängt nichts an');
  const sie = (text.match(/\b(Sie|Ihnen|Ihre[rsmn]?)\b/g) ?? []).length;
  const du = (text.match(/\b(du|dir|dich|dein[esmr]?|euch|eure[rsmn]?)\b/gi) ?? []).length;
  if (sie >= 2 && du >= 2) out.push('Sie und Du gemischt');
  if (a.draft.threadId && a.mailboxId !== a.draft.mailboxId) {
    const von = a.mailboxes.find((m) => m.id === a.mailboxId)?.address ?? '';
    out.push(`Absender ${von} ist nicht das Postfach, in dem die Mail ankam`);
  }
  const eigene = new Set(a.mailboxes.map((m) => m.address.toLowerCase()));
  if (a.to.length && a.to.every((t) => eigene.has(t.address.toLowerCase())))
    out.push('Empfänger ist nur ein eigenes Postfach');
  return out;
}
